import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { approveLeave, getApprovedListByIdAndDateRange, getLeaveApproveList } from "../../Redux/Leave/Action";
import { FaCheck } from "react-icons/fa6";
import "./LeaveApply.css";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { FaTimes } from "react-icons/fa";
import { empList } from "../../Redux/DailyUpdateApproval/Action";
import Select from "react-select";
import NewDataTable from "../DataTable/NewDataTable";
import { startOfMonth , endOfMonth,format} from "date-fns";
import DatePicker from 'react-datepicker';



const LeaveApproval = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const { leaveapprovelist, leavelistbyidandyear } = useSelector((store) => store.leave);
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);
  const [activeTab, setActiveTab] = useState("pending");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
  const [toDate, setToDate] = useState(endOfMonth(new Date()));


  useEffect(() => {
    dispatch(empList(token, "All"));
    dispatch(getLeaveApproveList(token, loginId));
  }, [dispatch, token, loginId]);

const options = [
  { value: "All", label: "All" },
  ...emplists.map((emp) => ({
    value: emp.loginId,
    label: `${emp.firstName?.trim() || ""} ${emp.lastName?.trim() || ""}`.trim(),
  })),
];


  const currentYear = new Date().getFullYear();

  // Generate last 10 years
  const yearOptions = Array.from({ length: 10 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });

  const [selectedYear, setSelectedYear] = useState({
    value: currentYear,
    label: currentYear.toString(),
  });

  const handleChange = (option) => {
    setSelectedYear(option);
  };

  useEffect(() => {
    if (options.length > 0 && selectedEmployee === null) {
      setSelectedEmployee(options[0]);
    }
  }, [options, selectedEmployee]);

  const handleEmpChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
  };

  useEffect(() => {
    dispatch(getApprovedListByIdAndDateRange(selectedEmployee?.value, format(fromDate, "yyyy-MM-dd"),format(toDate, "yyyy-MM-dd"), token));
  }, [dispatch, fromDate, toDate ,selectedEmployee]);


  const handleApproveLeave = async (row, type) => {
    const leaveId = row.leaveId;
    const status = type;
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      dispatch(approveLeave(loginId, leaveId, status, token))
        .then((response) => {
          if (response.statusMessage === "SUCCESS") {
            dispatch(getLeaveApproveList(token, loginId));
            Swal.fire({
              title: "Success!",
              text: response.statusDesc,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
            const selectedEmp = emplists.find(emp => emp.loginId === row.loginId);
            const opt = {
              value: selectedEmp.loginId,
              label: `${selectedEmp?.firstName || ''} ${selectedEmp?.lastName || ''}`.trim(),
            }
            setSelectedEmployee(opt);
            setActiveTab("approved");
          } else {
            Swal.fire({
              title: "Error!",
              text: response.statusDesc,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error initiating the leave details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };


  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  const columns = [
    {
      name: "SN",
      cell: (_, index) => index + 1,
      sortable: false,
      width: "80px",
      align: "center",
    },
    {
      name: "Name",
      selector: (row) => row?.name || "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Leave Code",
      selector: (row) => row?.leaveCode || "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Start Date",
      selector: (row) => row?.startDate ??  "-",
      sortable: true,
      align: "center",
    },
    {
      name: "End Date",
      selector: (row) => row?.endDate ?? "-",
      sortable: true,
      align: "center",
    },
    {
      name: "No of Days",
      selector: (row) => row?.noOfDays ?? "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Remark",
      selector: (row) => row?.remark || "-",
      sortable: true,
      align: "left",
    },
    {
      name: "Status",
      selector: (row) => row?.status || "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      width: "226px",
      align: "center",
      cell: (row) => (
        <div>
          <Tooltip text="Approve">
            <button
              type="button"
              className="btn btn-success btn-sm me-2"
              onClick={() => handleApproveLeave(row, "S")}
            >
              <FaCheck />
            </button>
          </Tooltip>
          <Tooltip text="Revert">
            <button
              type="button"
              className="btn btn-danger btn-sm me-2"
              onClick={() => handleApproveLeave(row, "R")}
            >
              <FaTimes />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div className="card3">
            <div className="card-body">
              <div className="tab-container d-flex w-100 mb-3 rounded-5 overflow-hidden shadow-sm">
                <div
                  className={`tab-item flex-fill text-center ${activeTab === "pending" ? "active-tab" : ""}`}
                  onClick={() => setActiveTab("pending")}
                >
                  Pending Leaves
                </div>
                <div
                  className={`tab-item flex-fill text-center ${activeTab === "approved" ? "active-tab" : ""}`}
                  onClick={() => setActiveTab("approved")}
                >
                  Approved Leaves
                </div>
              </div>



              <div className="d-flex justify-content-end mb-3">
                {activeTab === "approved" && (
                  <>
                    <div className="col-auto d-flex align-items-center mb-2">
                      <b>
                        <label className="me-1 mb-0 custom-label cstm-label">From Date:</label>
                      </b>
                      <DatePicker
                        selected={fromDate}
                        onChange={(newValue) => setFromDate(newValue)}
                        className="form-control me-3"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        onKeyDown={(event) => event.preventDefault()}
                      />

                      <b>
                        <label className="me-1 ms-2  mb-0 custom-label cstm-label">To Date:</label>
                      </b>
                      <DatePicker
                        selected={toDate}
                        onChange={(newValue) => setToDate(newValue)}
                        className="form-control me-3"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        onKeyDown={(event) => event.preventDefault()}
                        minDate={fromDate}
                      />
                    </div>
                    <div className="col-auto d-flex align-items-center mb-2 ms-2">
                      <b>
                        <label className="custom-label mt-1">Employee:</label>
                      </b>
                    </div>
                    <div className="col-sm-2  ms-1">
                      <Select
                        options={options}
                        value={selectedEmployee}
                        onChange={handleEmpChange}
                        placeholder="Select Employee"
                        isClearable
                      />
                    </div>
                  </>
                )}
              </div>


              {activeTab === "pending" && (
                <NewDataTable
                  columns={columns}
                  data={leaveapprovelist || []}
                  tableName="PENDING LEAVES"
                  defaultRowsPerPage={8}
                />
              )}
              {activeTab === "approved" && (

                <NewDataTable
                  columns={columns.filter(col => col.name !== "Status" && col.name !== "Action")}
                  data={leavelistbyidandyear || []}
                  tableName="APPROVED LEAVES"
                  defaultRowsPerPage={8}
                />
              )}
              <p className="text-muted mt-2">
                <small>
                  <i>
                    <span className="text-danger">Note: </span>
                    S-Success , A-Applied , R-Reverted
                  </i>{" "}
                  <i>
                    CL-Casual Leave, COM-Comp Off, LOP-Loss of Pay
                  </i>
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveApproval;
